// extracted by mini-css-extract-plugin
export default {"Answer":"AnswerDialog_Answer__Evdpv","Answer__Input":"AnswerDialog_Answer__Input__o7J4E"};